import { JsonPipe } from '@angular/common';
import { Component, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IRestrictedCharsError } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-dialog-invalid-reference-number',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatDialogActions, MatDialogClose],
  templateUrl: './dialog-invalid-reference-number.component.html',
  styleUrl: './dialog-invalid-reference-number.component.scss',
})
export class DialogInvalidReferenceNumberComponent {
  readonly dialogRef = inject(MatDialogRef<DialogInvalidReferenceNumberComponent>);
  public data = inject<IRestrictedCharsError>(MAT_DIALOG_DATA);
  private refData: IRestrictedCharsError;
  referenceNumber: string;
  invalidData: string;

  constructor() {
    this.refData = this.data;
    this.invalidData = this.data.restrictedChars;
  }
}
